module.exports = __webpack_public_path__ + "static/img/NBTM.1e9e3009.png";